// Staff listing status filter — mirrors the backend ListStatusFilter
// (backend/app/schemas/lifecycle.py). Drives the status dropdown on the
// Exhibitions / Zones / Exhibits listings. The listings default to the first
// option, "Draft + Published" (value "active"); the rest reveal archived /
// purged tombstones. "active" maps to draft + published on the wire.
export type ListStatus = "active" | "archived" | "purged" | "all";

export const LIST_STATUS_OPTIONS: { value: ListStatus; label: string }[] = [
  { value: "active", label: "Draft + Published" },
  { value: "archived", label: "Archived" },
  { value: "purged", label: "Purged" },
  { value: "all", label: "All" },
];
